/* eslint-disable no-nested-ternary */
/* eslint-disable operator-linebreak */
import { FormikValues, getIn } from 'formik';
import { FormType } from '@constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const keys = (values: FormikValues, template: string): any => {
  const { THIRDPARTY, COURT, FAMILYVIOLENCESCHEME, EXTENSION, INFRINGEMENTEXTENSION, INSTALMENT, REVIEW, NOMINATION } = FormType;

  const listObligationFields = () => {
    const temp: string[] = [];
    if (template === THIRDPARTY || template === FAMILYVIOLENCESCHEME) {
      values.obligations.forEach((obligation: string, index: number) => {
        temp.push(`obligations.${index}.value`);
      });
    }
    return temp;
  };

  const listAgencyFields = () => {
    const temp: string[] = [];
    if (template === FAMILYVIOLENCESCHEME) {
      values.AgencyNames.forEach((agencyName: string, index: number) => {
        temp.push(`AgencyNames.${index}.value`);
      });
    }
    return temp;
  };
  const listArrayVFields = (arrayFields: string) => {
    const temp: string[] = [];
    if (template === FAMILYVIOLENCESCHEME) {
      getIn(values, arrayFields).forEach((arrayFieldName: string, index: number) => {
        temp.push(`${arrayFields}.${index}.value`);
      });
    }
    return temp;
  };
  const checkIsArrayVFieldsEmpty = (arrayFieldsName: string): boolean => {
    let isContainValue = false;
    getIn(values, arrayFieldsName).forEach((arrayFieldName: string, index: number) => {
      if (!isContainValue) {
        isContainValue = !!`${arrayFieldsName}.${index}.value`;
      }
    });
    return isContainValue;
  };

  /* Services - Third Party Keys */
  const thirdPartyKeys = {
    tpIndividualContactNumber: ['IndividualContactNumber', 'IndividualContactNumber.ContactNumber', 'IndividualContactNumber.NumberType'],
    tpOrganisationContactNumber: ['OrganisationContactNumber', 'OrganisationContactNumber.ContactNumber', 'OrganisationContactNumber.NumberType'],
    tpUserContactNumber: ['UserContactNumber', 'UserContactNumber.ContactNumber', 'UserContactNumber.NumberType'],
    tpOrganisationAddress: [
      'OrganisationAddress',
      'OrganisationAddress.LineOne',
      'OrganisationAddress.LineTwo',
      'OrganisationAddress.Suburb',
      'OrganisationAddress.State',
      'OrganisationAddress.Postcode',
      'OrganisationAddress.Country',
    ],
    tpOrganisationPostalAddress: [
      'OrganisationPostalAddress.LineOne',
      'OrganisationPostalAddress.LineTwo',
      'OrganisationPostalAddress.Suburb',
      'OrganisationPostalAddress.State',
      'OrganisationPostalAddress.Postcode',
      'OrganisationPostalAddress.Country',
    ],
    tpResidentialAddress: [
      'ResidentialAddress',
      'ResidentialAddress.LineOne',
      'ResidentialAddress.LineTwo',
      'ResidentialAddress.Suburb',
      'ResidentialAddress.State',
      'ResidentialAddress.Postcode',
      'ResidentialAddress.Country',
    ],
    tpResidentialPostalAddress: [
      'ResidentialPostalAddress',
      'ResidentialPostalAddress.LineOne',
      'ResidentialPostalAddress.LineTwo',
      'ResidentialPostalAddress.Suburb',
      'ResidentialPostalAddress.State',
      'ResidentialPostalAddress.Postcode',
      'ResidentialPostalAddress.Country',
    ],
    tpStep3Individual: ['WhoAreYouNominating', 'MrMrsMsMissOther', 'GivenNames', 'FamilyName', values.NoEmailAddress === true ? [] : 'EmailAddressOptional'],
    tpStep3Organisation: [
      'WhoAreYouNominating',
      'OrganisationName',
      'IsOrganisationAddressDifferentFromPostal',
      'YourReferenceNumberWithinTheOrganisationOptional',
      values.NoEmailAddressTwo === true ? [] : 'EmailAddressOptionalTwo',
    ],
    tpLicenseState: ['DriverLicenceNumberOptional', 'StatecountryOfIssue', values.StatecountryOfIssue === 'Australia' ? 'LicenceState' : []],
    tpObligations: ['obligations', ...listObligationFields()],
  };
  const {
    tpIndividualContactNumber,
    tpOrganisationContactNumber,
    tpUserContactNumber,
    tpOrganisationAddress,
    tpOrganisationPostalAddress,
    tpResidentialAddress,
    tpResidentialPostalAddress,
    tpStep3Individual,
    tpStep3Organisation,
    tpLicenseState,
    tpObligations,
  } = thirdPartyKeys;
  const thirdPartyValidationKeys = {
    page1: ['WhatDoesThisAuthorisationCover'],
    page2: [
      'WhatFinesDoesThisAuthorisationCover',
      'HowLongWillThisAuthorisationLast',
      values.HowLongWillThisAuthorisationLast === 'Date' ? 'authlast' : null,
      values.WhatFinesDoesThisAuthorisationCover === 'No' ? 'authexclude' : null,
      ...(values.WhatFinesDoesThisAuthorisationCover === 'No' ? tpObligations : []),

    ],
    page3:
      values.WhoAreYouNominating === ''
        ? ['WhoAreYouNominating']
        : values.WhoAreYouNominating === 'individual'
        ? [...tpStep3Individual, ...tpIndividualContactNumber]
        : [
            ...tpStep3Organisation,
            ...tpOrganisationAddress,
            ...(values.IsOrganisationAddressDifferentFromPostal === 'true' ? tpOrganisationPostalAddress : []),
            ...tpOrganisationContactNumber,
          ],
    page4: [
      'MrMrsMsMissOtherTwo',
      'FirstOrGivenNames',
      'LastNameOrFamilyName',
      'IsResidentialAddressSameAsPostal',
      'DateOfBirth',
      ...tpResidentialAddress,
      ...(values.IsResidentialAddressSameAsPostal === 'true' ? tpResidentialPostalAddress : []),
      ...tpUserContactNumber,
      ...(values.NoDriverLicence ? [] : tpLicenseState),
      ...(values.NoEmailAddressThree ? [] : ['EmailAddressOptionalThree', 'EMAIL_TO']),
    ],
    page5: [],
    page6: ['consentToDeclaration'],
    page7: [],
  };
  /* Services - Third Party Keys --end */

  /* Services - Court Keys */
  const courtKeys = {
    courtUserContactNumber: ['CourtContactNumber', 'CourtContactNumber.ContactNumber'],
    courtSummonsAddress: [
      'SummonsAddress',
      'SummonsAddress.LineOne',
      'SummonsAddress.LineTwo',
      'SummonsAddress.Suburb',
      'SummonsAddress.State',
      'SummonsAddress.Postcode',
      'SummonsAddress.Country',
    ],
    courtResidentialAddress: [
      'ResidentialAddress',
      'ResidentialAddress.LineOne',
      'ResidentialAddress.LineTwo',
      'ResidentialAddress.Suburb',
      'ResidentialAddress.State',
      'ResidentialAddress.Postcode',
      'ResidentialAddress.Country',
    ],
    courtCompanyAddress: [
      'CompanyAddress',
      'CompanyAddress.LineOne',
      'CompanyAddress.LineTwo',
      'CompanyAddress.Suburb',
      'CompanyAddress.State',
      'CompanyAddress.Postcode',
      'CompanyAddress.Country',
    ],
    courtCompanyPostalAddress: [
      'CompanyPostalAddress',
      'CompanyPostalAddress.LineOne',
      'CompanyPostalAddress.LineTwo',
      'CompanyPostalAddress.Suburb',
      'CompanyPostalAddress.State',
      'CompanyPostalAddress.Postcode',
      'CompanyPostalAddress.Country',
    ],
    courtLicenseState: ['DRIVER_LICENCE', 'StatecountryOfIssue', values.StatecountryOfIssue === 'Australia' ? 'LicenceState' : []],
  };
  const { courtUserContactNumber, courtSummonsAddress, courtResidentialAddress, courtLicenseState, courtCompanyAddress, courtCompanyPostalAddress } = courtKeys;
  const courtValidationKeys = {
    page0: [],
    page1: ['OBLIGATION_NUMBER'],
    page2: [
      values.OffenceDateRequired ? 'OFFENCE_DATE' : '',
      values.HearingDateRequired ? 'HEARING_DATE' : '',
      values.LicenceRequired ? 'DRIVER_LICENCE' : '',
      values.RegistrationRequired ? 'VEHICLE_REGISTRATION' : '',
      values.DOBRequired ? 'DOB' : '',
    ],
    page3: [
      'SaveYesNo',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'email' || values.SaveOptions === 'both') ? 'saveEmail' : '',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'mobile' || values.SaveOptions === 'both') ? 'saveMobile' : '',
    ],
    page4: [],
    page5: [
      'TitleMrMrsMsMissOther',
      'DOB',
      'GivenNames',
      'FamilyName',
      'EMAIL_TO',
      ...(values.NoDriverLicence ? [] : courtLicenseState),
      ...(values.NoEmail ? [] : ['Email', 'EMAIL_TO']),
      ...courtSummonsAddress,
      'HasDifferentResidentialAddress',
      ...(values.HasDifferentResidentialAddress === 'true' ? courtResidentialAddress : []),
      ...courtUserContactNumber,
    ],
    page6: [
      'TitleMrMrsMsMissOther',
      'DOB',
      'GivenNames',
      'FamilyName',
      'PositionOfThePersonWithinTheCompany',
      values.PositionOfThePersonWithinTheCompany === 'OTHER' ? 'OtherPosition' : '',
      'CompanyName',
      'AbnacnType',
      values.AbnacnType === 'ABN' ? 'AbnNo' : '',
      values.AbnacnType === 'ACN' ? 'AcnNo' : '',
      ...(values.NoDriverLicence ? [] : courtLicenseState),
      ...(values.NoEmail ? [] : ['Email', 'EMAIL_TO']),
      ...courtCompanyAddress,
      'HasDifferentCompanyAddress',
      ...(values.HasDifferentCompanyAddress === 'true' ? courtCompanyPostalAddress : []),
      ...courtUserContactNumber,
    ],
    page7: [],
    page8: [],
    page9: [],
    page10: [],
    page11: ['declaration', values.SeriousObligation ? 'intend' : ''],
  };

  /* Services - Court Keys --end */

  /* Services - Extension Keys */

  const extensionKeys = {
    extensionUserContactNumber: ['ExtensionContactNumber', 'ExtensionContactNumber.ContactNumber', 'ExtensionContactNumber.NumberType'],
    extensionPostalAddress: [
      'ExtensionPostalAddress',
      'ExtensionPostalAddress.LineOne',
      'ExtensionPostalAddress.LineTwo',
      'ExtensionPostalAddress.Suburb',
      'ExtensionPostalAddress.State',
      'ExtensionPostalAddress.Postcode',
      'ExtensionPostalAddress.Country',
    ],
    extensionResidentialAddress: [
      'ExtensionResidentialAddress',
      'ExtensionResidentialAddress.LineOne',
      'ExtensionResidentialAddress.LineTwo',
      'ExtensionResidentialAddress.Suburb',
      'ExtensionResidentialAddress.State',
      'ExtensionResidentialAddress.Postcode',
      'ExtensionResidentialAddress.Country',
    ],
    extensionLicenseState: ['DRIVER_LICENCE', 'StatecountryOfIssue', values.StatecountryOfIssue === 'Australia' ? 'LicenceState' : []],
  };
  const { extensionUserContactNumber, extensionLicenseState, extensionPostalAddress, extensionResidentialAddress } = extensionKeys;
  const extensionValidationKeys = {
    page0: [],
    page1: ['OBLIGATION_NUMBER'],
    page2: [
      values.OffenceDateRequired ? 'OFFENCE_DATE' : '',
      values.HearingDateRequired ? 'HEARING_DATE' : '',
      values.LicenceRequired ? 'DRIVER_LICENCE' : '',
      values.RegistrationRequired ? 'VEHICLE_REGISTRATION' : '',
      values.DOBRequired ? 'DOB' : '',
    ],
    page3: [
      'SaveYesNo',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'email' || values.SaveOptions === 'both') ? 'saveEmail' : '',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'mobile' || values.SaveOptions === 'both') ? 'saveMobile' : '',
    ],
    page4: [],
    page5: ['DateToPay'],
    page6: [
      'TitleMrMrsMsMissOther',
      'DOB',
      'GivenNames',
      'FamilyName',
      ...extensionPostalAddress,
      'HasDifferentResidentialAddress',
      ...(values.HasDifferentResidentialAddress === 'true' ? extensionResidentialAddress : []),
      ...(values.NoDriverLicence ? [] : extensionLicenseState),
      ...(values.NoEmail ? [] : ['Email', 'EMAIL_TO']),
      ...extensionUserContactNumber,
    ],
    page7: ['ExceptionalCircumstances', ...(values.DetailsForCircumstances ? ['DetailsForCircumstances'] : [])],
    page8: [],
    page9: ['declaration'],
    page10: [],
  };

  /* Services - Extension Keys --end */

  /* Services - FVS Keys */
  const fvsKeys = {
    fvsVictimResidentialAddress: [
      'FVSResidentialAddress',
      'FVSResidentialAddress.LineOne',
      'FVSResidentialAddress.LineTwo',
      'FVSResidentialAddress.Suburb',
      'FVSResidentialAddress.State',
      'FVSResidentialAddress.Postcode',
      'FVSResidentialAddress.Country',
    ],
    fvsVictimPostalAddress: [
      'FVSPostalAddress',
      'FVSPostalAddress.LineOne',
      'FVSPostalAddress.LineTwo',
      'FVSPostalAddress.Suburb',
      'FVSPostalAddress.State',
      'FVSPostalAddress.Postcode',
      'FVSPostalAddress.Country',
    ],
    fvsVictimDriverLicence: ['DRIVER_LICENCE', 'StatecountryOfIssue', values.StatecountryOfIssue === 'Australia' ? 'LicenceState' : []],
    fvsVictimContactDetails: [
      'IndividualContactNumber',
      'IndividualContactNumber.ContactNumber',
      'SafestContactTime',
      'PhoneMessagePrompt',
      'InterpreterRequiredPrompt',
    ],
    fvsRepresentativePostalAddress: [
      'RepresentativePostalAddress',
      'RepresentativePostalAddress.LineOne',
      'RepresentativePostalAddress.LineTwo',
      'RepresentativePostalAddress.Suburb',
      'RepresentativePostalAddress.State',
      'RepresentativePostalAddress.Postcode',
      'RepresentativePostalAddress.Country',
    ],
    fvsRepresentativeContactDetails: ['FVSContactNumber', 'FVSContactNumber.ContactNumber'],
    fvsAgencyNames: ['AgencyNames', ...listAgencyFields()],
    fvsInfringementNums: ['InfringementNums', ...listArrayVFields('InfringementNums')],
    fvsAOffence: ['AOffence', ...listArrayVFields('AOffence')],
    fvsObligations: ['obligations', ...listObligationFields()],
  };
  const {
    fvsVictimResidentialAddress,
    fvsVictimPostalAddress,
    fvsVictimDriverLicence,
    fvsVictimContactDetails,
    fvsRepresentativePostalAddress,
    fvsRepresentativeContactDetails,
    fvsAgencyNames,
    fvsObligations,
    fvsInfringementNums,
    fvsAOffence,
  } = fvsKeys;
  const isPostalAddressEmpty = () => {
    if (template === FormType.FAMILYVIOLENCESCHEME) {
      return values.FVSPostalAddress.LineOne === '' && values.FVSPostalAddress.Postcode === '' && values.FVSPostalAddress.State === '' && values.FVSPostalAddress.Suburb === '';
    }
    return false;
  };
  const isResidentialAddressEmpty = () => {
    if (template === FormType.FAMILYVIOLENCESCHEME) {
      return (
        values.FVSResidentialAddress.LineOne === '' &&
        values.FVSResidentialAddress.Postcode === '' &&
        values.FVSResidentialAddress.State === '' &&
        values.FVSResidentialAddress.Suburb === ''
      );
    }
    return false;
  };
  const fvsValidationKeys = {
    page0: [],
    page1: ['OBLIGATION_NUMBER'],
    page2: [
      values.OffenceDateRequired ? 'OFFENCE_DATE' : '',
      values.HearingDateRequired ? 'HEARING_DATE' : '',
      values.LicenceRequired ? 'DRIVER_LICENCE' : '',
      values.RegistrationRequired ? 'VEHICLE_REGISTRATION' : '',
      values.DOBRequired ? 'DOB' : '',
    ],
    page3: ['Has7DayNotice', values.NoActionsTaken ? 'NoActionsTaken' : 'ActionsTakenOnFine', 'HasLinkBwFVSAndFines', 'HasEvidenceToSupport'],
    page4: [
      'SaveYesNo',
      'SaveOptions',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'email' || values.SaveOptions === 'both') ? 'saveEmail' : '',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'mobile' || values.SaveOptions === 'both') ? 'saveMobile' : '',
    ],
    page5: ['ApplicationLodger', 'ConsentToThirdParty'],
    page6: [
      'GivenNames',
      'FamilyName',
      'DOB',
      ...(values.NoDriverLicence ? [] : fvsVictimDriverLicence),
      ...(values.NoFixedAddress || values.NoResidentialAddress ? [] : fvsVictimResidentialAddress),
      ...(values.NoFixedAddress || values.NoResidentialAddress ? [] : ['DeliveryAddressType']),
      ...((!values.NoSafePostalAddress && (values.NoFixedAddress || values.NoResidentialAddress || values.DeliveryAddressType === 'PostalAddress')) ||
      (values.NoSafePostalAddress && values.DeliveryAddressType === 'PostalAddress')
        ? fvsVictimPostalAddress
        : []),
      ...((!isResidentialAddressEmpty() || !isPostalAddressEmpty()) &&
      (values.NoFixedAddress || values.NoResidentialAddress || values.DeliveryAddressType === 'PostalAddress' || values.DeliveryAddressType === 'ResidentialAddress')
        ? ['IsEmailRequired']
        : []),
      ...((isPostalAddressEmpty() && isResidentialAddressEmpty()) || values.IsEmailRequired === 'true' || values.DeliveryAddressType === 'EmailAddress'
        ? ['Email', 'SendEmailCopy']
        : []),
      'PhoneApplicant',
      ...(values.PhoneApplicant === 'true' ? fvsVictimContactDetails : []),
      ...(values.PhoneApplicant === 'true' && values.InterpreterRequiredPrompt === 'true' ? ['AlternativeLanguage'] : []),
    ],
    page7: ['HasScaredFeelings', 'HasRiskAssessment', 'ContactSpecialist'],
    page8: [
      ...(values.DisabilityDescription ? ['DisabilityDescription'] : []),
      ...(values.GenderSelfDescribed ? ['GenderSelfDescribed'] : []),
      ...(values.NativeLanguage ? ['NativeLanguage'] : []),
    ],
    page9: [
      ...(values.relevantObs && values.relevantObs.length !== 0 ? ['WhichOtherFines'] : []),
      ...(values.AdditionalFinesToInclude === 'true' ? fvsAgencyNames : []),
      ...(values.InfringementFinesToInclude === 'true' && checkIsArrayVFieldsEmpty('InfringementNums') ? fvsInfringementNums : []),
      ...(values.InfringementFinesToInclude === 'true' && checkIsArrayVFieldsEmpty('AOffence') ? fvsAOffence : []),
    ],
    page10: ['WhatWouldYouLikeToHappen', 'DOBOptional', ...(values.WhatWouldYouLikeToHappen === 'AboveCombination' ? ['HowDealtWithFines'] : []), 'GivenNamesOptional', 'FamilyNameOptional', 'DriverLicenceNumberOptional'],
    page11: ['RemoveFines', ...(values.RemoveFines === 'true' ? ['ReincludeFines'] : [])],
    page12: [...(values.UnableToObtainAdoc ? ['StatutoryUploadFileSectionError'] : ['ReportUploadFileSectionError']), 'SupportingFilesDescription'],
    page13: ['ReasonForApplication', 'OtherSupportingFilesDescription'],
    page14: [
      'RepresentativeGivenName',
      'RepresentativeFamilyName',
      'RepresentativeRelationshipToVictim',
      'RepresentativeEmailAddress',
      'RepresentativeRequestsEmailCopyBool',
      'RepresentativeAllowsPhoneCommunicationBool',
      ...(values.RepresentativeCompanyName ? ['RepresentativeCompanyName'] : []),
      ...(values.RepresentativeCompanyPosition ? ['RepresentativeCompanyPosition'] : []),
      ...(values.RepresentativeAllowsPhoneCommunicationBool === 'Yes' ? ['RepresentativePreferredContactDayTime'] : []),
      ...fvsRepresentativePostalAddress,
      ...fvsRepresentativeContactDetails,
    ],
    page15: [
      'GivenNames',
      'FamilyName',
      'DOB',
      ...(values.NoDriverLicence ? [] : fvsVictimDriverLicence),
      ...(values.NoFixedAddress || values.NoResidentialAddress ? [] : fvsVictimResidentialAddress),
      'DeliveryAddressType',
      ...(values.DeliveryAddressType === 'PostalAddress' ? fvsVictimPostalAddress : []),
      'IsEmailRequired',
      ...(values.IsEmailRequired === 'true' ? ['Email'] : []),
      'PhoneApplicant',
      ...(values.PhoneApplicant === 'true' ? fvsVictimContactDetails : []),
      ...(values.PhoneApplicant === 'true' && values.InterpreterRequiredPrompt === 'true' ? ['AlternativeLanguage'] : []),
    ],
    page16: ['HasScaredFeelings', 'HasRiskAssessment', 'ContactSpecialist'],
    page17: [
      ...(values.DisabilityDescription ? ['DisabilityDescription'] : []),
      ...(values.GenderSelfDescribed ? ['GenderSelfDescribed'] : []),
      ...(values.NativeLanguage ? ['NativeLanguage'] : []),
    ],
    page18: [
      'RegisteredFinesToInclude',
      'InfringementFinesToInclude',
      ...(values.RegisteredFinesToInclude === 'true') ? ['AdditionalFinesType'] : [],
      ...(values.RegisteredFinesToInclude === 'true' && values.AdditionalFinesType !== 'All eligible outstanding fines' && values.AdditionalFinesType !== '' ? fvsObligations : []),
      ...(values.InfringementFinesToInclude === 'true' ? fvsAgencyNames : []),
      ...(values.InfringementFinesToInclude === 'true' && checkIsArrayVFieldsEmpty('InfringementNums') ? fvsInfringementNums : []),
      ...(values.InfringementFinesToInclude === 'true' && checkIsArrayVFieldsEmpty('AOffence') ? fvsAOffence : []),
    ],
    page19: ['WhatWouldYouLikeToHappen', ...(values.WhatWouldYouLikeToHappen === 'AboveCombination' ? ['HowDealtWithFines'] : []), 'DOBOptional', 'GivenNamesOptional', 'FamilyNameOptional', 'DriverLicenceNumberOptional'],
    page20: ['HasPaymentArrangement', ...(values.HasPaymentArrangement === 'true' ? ['RemoveFines'] : []), ...(values.RemoveFines === 'true' ? ['ReincludeFines'] : [])],
    page21: [...(values.UnableToObtainAdoc ? ['StatutoryUploadFileSectionError'] : ['ReportUploadFileSectionError'])],
    page22: ['ReasonForApplication'],
    page24: ['declaration'],
  };
  /* Services - FVS Keys --end */

  /* Services - Instalment Keys --start */
  const InstalmentKeys = {
    instalmentIndividualContactNumber: ['IndividualContactNumber', 'IndividualContactNumber.ContactNumber', 'IndividualContactNumber.NumberType'],
    instalmentIndividualPostalAddress: [
      'IndividualPostalAddress',
      'IndividualPostalAddress.LineOne',
      'IndividualPostalAddress.LineTwo',
      'IndividualPostalAddress.Suburb',
      'IndividualPostalAddress.State',
      'IndividualPostalAddress.Postcode',
      'IndividualPostalAddress.Country',
    ],
    instalmentLicense: ['DRIVER_LICENCE', 'StatecountryOfIssue', values.StatecountryOfIssue === 'Australia' ? 'LicenceState' : []],
    instalmentResidentialAddress: [
      'IndividualResidentialAddress',
      'IndividualResidentialAddress.LineOne',
      'IndividualResidentialAddress.LineTwo',
      'IndividualResidentialAddress.Suburb',
      'IndividualResidentialAddress.State',
      'IndividualResidentialAddress.Postcode',
      'IndividualResidentialAddress.Country',
    ],
    instalmentCompanyAddress: [
      'CompanyStreetAddress',
      'CompanyStreetAddress.LineOne',
      'CompanyStreetAddress.LineTwo',
      'CompanyStreetAddress.Suburb',
      'CompanyStreetAddress.State',
      'CompanyStreetAddress.Postcode',
      'CompanyStreetAddress.Country',
    ],
    instalmentCompanyPostalAddress: [
      'CompanyPostalAddress',
      'CompanyPostalAddress.LineOne',
      'CompanyPostalAddress.LineTwo',
      'CompanyPostalAddress.Suburb',
      'CompanyPostalAddress.State',
      'CompanyPostalAddress.Postcode',
      'CompanyPostalAddress.Country',
    ],
    instalmentCompanyContact: ['CompanyContactNumber', 'CompanyContactNumber.ContactNumber', 'CompanyContactNumber.NumberType'],
  };
  const {
    instalmentIndividualContactNumber,
    instalmentResidentialAddress,
    instalmentIndividualPostalAddress,
    instalmentLicense,
    instalmentCompanyAddress,
    instalmentCompanyPostalAddress,
    instalmentCompanyContact
  } = InstalmentKeys;
  const instalmentValidationKeys = {
    page0: [],
    page1: ['OBLIGATION_NUMBER'],
    page2: [],
    page3: [
      values.OffenceDateRequired ? 'OFFENCE_DATE' : '',
      values.HearingDateRequired ? 'HEARING_DATE' : '',
      values.LicenceRequired ? 'DRIVER_LICENCE' : '',
      values.RegistrationRequired ? 'VEHICLE_REGISTRATION' : '',
      values.DOBRequired ? 'DOB' : '',
    ],
    page4: [
      'SaveYesNo',
      'SaveOptions',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'email' || values.SaveOptions === 'both') ? 'saveEmail' : '',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'mobile' || values.SaveOptions === 'both') ? 'saveMobile' : '',
    ],
    page6: [values.NoInfoApplies ? 'NoInfoApplies' : 'MoreInfoAboutMatters'],
    page7: [
      'DetailsForUpfrontPaymentCircumstances',
      'SupportingDocUpfrontPaymentUploadFileSectionError'
    ],
    page8: [
      'receiveCenterlinkPayments',
      values.receiveCenterlinkPayments === 'true' && values.instalmentDeducted === 'true' ? 'fortnightlyPaymentAmount' : '',
      values.receiveCenterlinkPayments === 'true' ? 'instalmentDeducted' : '',
      values.receiveCenterlinkPayments === 'true' && values.instalmentDeducted === 'true' ? 'centrelinkPaymentType' : '',
      values.receiveCenterlinkPayments === 'true' && values.instalmentDeducted === 'true' ? 'centrelinkRefNo' : '',
      values.receiveCenterlinkPayments === 'true' && values.instalmentDeducted === 'true' && values.centrelinkPaymentType === 'Other' ? 'specifyPaymentType' : '',
      values.receiveCenterlinkPayments === 'true' && values.instalmentDeducted === 'true' ? 'centrelinkCheck' : ''
    ],
    page9: [
      'instalmentFrequency',
      'instalmentAmount',
      'firstInstalmentDate'
    ],
    page10: [
      'haveExceptionalCircumstances',
      values.haveExceptionalCircumstances === 'true' && 'DetailsOfFinancialCircumstances',
      'SupportingFinancialDocUploadFileSectionError',
      'numberOfDependents'
    ],
    page11: [
      ...(values.isDebtorTypeIndividual ? ['fortnightlyIncomeAfterTax', 'fortnightlyExpenses'] : ['quarterlyProfit', 'quarterlyLoss']),
    ],
    page12: [
      ...(values.isDebtorTypeIndividual ?
      ['IndividualGivenName',
      'IndividualFamilyName',
      'DOB',
      ...instalmentIndividualContactNumber,
      ...instalmentIndividualPostalAddress,
      'IndividualHasDifferentResidentialAddress',
      ...(values.IndividualHasDifferentResidentialAddress === 'true' ? instalmentResidentialAddress : []),
      ...(values.NoDriverLicence ? [] : instalmentLicense),
      ...(values.IndividualHasNoEmail ? [] : ['IndividualEmail', 'IndividualEmailTo', 'IndividualReceiveDocs']),
      ] : []),
      ...(values.isDebtorTypeCompany ?
      ['CompanyGivenName',
      'CompanyFamilyName',
      'PositionInCompany',
      'CompanyHasDifferentPostalAddress',
      ...instalmentCompanyContact,
      'CompanyName',
      'AbnOrAcnType',
      values.AbnOrAcnType === 'ABN' ? 'AbnNo' : [],
      values.AbnOrAcnType === 'ACN' ? 'AcnNo' : [],
      ...instalmentCompanyAddress,
      ...(values.CompanyHasDifferentPostalAddress === 'true' ? instalmentCompanyPostalAddress : []),
      ...(values.CompanyHasNoEmail ? [] : ['CompanyEmail', 'CompanyEmailTo', 'CompanyReceiveDocs']),
      ] : [])
    ],
    page13: [],
    page14: ['declaration']
  };

  /* Services - Infringement Extension Keys --end */

  const InfringementExtensionKeys = {
    infringementExtensionIndividualContactNumber: ['IndividualContactNumber', 'IndividualContactNumber.ContactNumber', 'IndividualContactNumber.NumberType'],
    infringementExtensionIndividualPostalAddress: [
      'IndividualPostalAddress',
      'IndividualPostalAddress.LineOne',
      'IndividualPostalAddress.LineTwo',
      'IndividualPostalAddress.Suburb',
      'IndividualPostalAddress.State',
      'IndividualPostalAddress.Postcode',
      'IndividualPostalAddress.Country',
    ],
    infringementExtensionLicense: ['DRIVER_LICENCE', 'StatecountryOfIssue', values.StatecountryOfIssue === 'Australia' ? 'LicenceState' : []],
    infringementExtensionResidentialAddress: [
      'IndividualResidentialAddress',
      'IndividualResidentialAddress.LineOne',
      'IndividualResidentialAddress.LineTwo',
      'IndividualResidentialAddress.Suburb',
      'IndividualResidentialAddress.State',
      'IndividualResidentialAddress.Postcode',
      'IndividualResidentialAddress.Country',
    ],
    infringementExtensionCompanyAddress: [
      'CompanyStreetAddress',
      'CompanyStreetAddress.LineOne',
      'CompanyStreetAddress.LineTwo',
      'CompanyStreetAddress.Suburb',
      'CompanyStreetAddress.State',
      'CompanyStreetAddress.Postcode',
      'CompanyStreetAddress.Country',
    ],
    infringementExtensionCompanyPostalAddress: [
      'CompanyPostalAddress',
      'CompanyPostalAddress.LineOne',
      'CompanyPostalAddress.LineTwo',
      'CompanyPostalAddress.Suburb',
      'CompanyPostalAddress.State',
      'CompanyPostalAddress.Postcode',
      'CompanyPostalAddress.Country',
    ],
    infringementExtensionCompanyContact: ['CompanyContactNumber', 'CompanyContactNumber.ContactNumber', 'CompanyContactNumber.NumberType'],
  };
  const {
    infringementExtensionIndividualContactNumber,
    infringementExtensionResidentialAddress,
    infringementExtensionIndividualPostalAddress,
    infringementExtensionLicense,
    infringementExtensionCompanyAddress,
    infringementExtensionCompanyPostalAddress,
    infringementExtensionCompanyContact
  } = InfringementExtensionKeys;
  const infringementExtensionValidationKeys = {
    page0: [],
    page1: ['OBLIGATION_NUMBER'],
    page2: [
      values.OffenceDateRequired ? 'OFFENCE_DATE' : '',
      values.HearingDateRequired ? 'HEARING_DATE' : '',
      values.LicenceRequired ? 'DRIVER_LICENCE' : '',
      values.RegistrationRequired ? 'VEHICLE_REGISTRATION' : '',
      values.DOBRequired ? 'DOB' : '',
    ],
    page3: [
      'OFFENCE_FIND_OUT_DATE',
      values.isHandedDownInPersonFieldRequired ? 'WasHandedInPerson' : ''
    ],
    page4: [
      'SaveYesNo',
      'SaveOptions',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'email' || values.SaveOptions === 'both') ? 'saveEmail' : '',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'mobile' || values.SaveOptions === 'both') ? 'saveMobile' : '',
    ],
    page5: [],
    page6: ['DetailsForCircumstances'],
    page7: [
      ...(values.isDebtorTypeIndividual ?
      ['IndividualGivenName',
      'IndividualFamilyName',
      'HasDifferentPostalAddress',
      'DOB',
      ...infringementExtensionIndividualContactNumber,
      ...infringementExtensionResidentialAddress,
      'IndividualHasDifferentPostalAddress',
      ...(values.IndividualHasDifferentPostalAddress === 'true' ? infringementExtensionIndividualPostalAddress : []),
      ...(values.NoDriverLicence ? [] : infringementExtensionLicense),
      ...(values.IndividualHasNoEmail ? [] : ['IndividualEmail', 'IndividualEmailTo']),
      'IndividualReceiveDocs'] : []),
      ...(values.isDebtorTypeCompany ?
      ['CompanyGivenName',
      'CompanyFamilyName',
      'PositionInCompany',
      'HasDifferentPostalAddress',
      ...infringementExtensionCompanyContact,
      'CompanyName',
      'AbnOrAcnType',
      values.AbnOrAcnType === 'ABN' ? 'AbnNo' : [],
      values.AbnOrAcnType === 'ACN' ? 'AcnNo' : [],
      ...infringementExtensionCompanyAddress,
      'CompanyHasDifferentPostalAddress',
      ...(values.CompanyHasDifferentPostalAddress === 'true' ? infringementExtensionCompanyPostalAddress : []),
      ...(values.CompanyHasNoEmail ? [] : ['CompanyEmail', 'CompanyEmailTo']),
      'CompanyReceiveDocs'] : [])
    ],
    page9: ['declaration'],
  };

  /* Services - Infringement Extension Keys --end */

  /* Services - Review Keys --start */
  const reviewKeys = {
    postalAddressFineholderDetails: [
      'PostalAddressFineholderDetails',
      'PostalAddressFineholderDetails.LineOne',
      'PostalAddressFineholderDetails.LineTwo',
      'PostalAddressFineholderDetails.Suburb',
      'PostalAddressFineholderDetails.State',
      'PostalAddressFineholderDetails.Postcode',
      'PostalAddressFineholderDetails.Country',
    ],
    residentialAddressFineholderDetails: [
      'ResidentialAddressFineholderDetails',
      'ResidentialAddressFineholderDetails.LineOne',
      'ResidentialAddressFineholderDetails.LineTwo',
      'ResidentialAddressFineholderDetails.Suburb',
      'ResidentialAddressFineholderDetails.State',
      'ResidentialAddressFineholderDetails.Postcode',
      'ResidentialAddressFineholderDetails.Country',
    ],
    postalAddressYourDetailsIndividual: [
      'PostalAddressYourDetailsIndividual',
      'PostalAddressYourDetailsIndividual.LineOne',
      'PostalAddressYourDetailsIndividual.LineTwo',
      'PostalAddressYourDetailsIndividual.Suburb',
      'PostalAddressYourDetailsIndividual.State',
      'PostalAddressYourDetailsIndividual.Postcode',
      'PostalAddressYourDetailsIndividual.Country',
    ],
    residentialAddressYourDetailsIndividual: [
      'ResidentialAddressYourDetailsIndividual',
      'ResidentialAddressYourDetailsIndividual.LineOne',
      'ResidentialAddressYourDetailsIndividual.LineTwo',
      'ResidentialAddressYourDetailsIndividual.Suburb',
      'ResidentialAddressYourDetailsIndividual.State',
      'ResidentialAddressYourDetailsIndividual.Postcode',
      'ResidentialAddressYourDetailsIndividual.Country',
    ],
    postalAddressYourDetailsThirdParty: [
      'PostalAddressYourDetailsThirdParty',
      'PostalAddressYourDetailsThirdParty.LineOne',
      'PostalAddressYourDetailsThirdParty.LineTwo',
      'PostalAddressYourDetailsThirdParty.Suburb',
      'PostalAddressYourDetailsThirdParty.State',
      'PostalAddressYourDetailsThirdParty.Postcode',
      'PostalAddressYourDetailsThirdParty.Country',
    ],
    postalAddressYourDetailsCompany: [
      'PostalAddressYourDetailsCompany',
      'PostalAddressYourDetailsCompany.LineOne',
      'PostalAddressYourDetailsCompany.LineTwo',
      'PostalAddressYourDetailsCompany.Suburb',
      'PostalAddressYourDetailsCompany.State',
      'PostalAddressYourDetailsCompany.Postcode',
      'PostalAddressYourDetailsCompany.Country',
    ],
    streetAddressYourDetailsCompany: [
      'StreetAddressYourDetailsCompany',
      'StreetAddressYourDetailsCompany.LineOne',
      'StreetAddressYourDetailsCompany.LineTwo',
      'StreetAddressYourDetailsCompany.Suburb',
      'StreetAddressYourDetailsCompany.State',
      'StreetAddressYourDetailsCompany.Postcode',
      'StreetAddressYourDetailsCompany.Country',
    ],
    contactNumberFineholderDetails: [
      'ContactNumberFineholderDetails',
      'ContactNumberFineholderDetails.ContactNumber'
    ],
    contactNumberYourDetailsIndividual: [
      'ContactNumberYourDetailsIndividual',
      'ContactNumberYourDetailsIndividual.ContactNumber'
    ],
    contactNumberYourDetailsThirdParty: [
      'ContactNumberYourDetailsThirdParty',
      'ContactNumberYourDetailsThirdParty.ContactNumber'
    ],
    contactNumberYourDetailsCompany: [
      'ContactNumberYourDetailsCompany',
      'ContactNumberYourDetailsCompany.ContactNumber'
    ],
    driverLicenceFineHolderDetails: ['DRIVER_LICENCE', 'PlaceOfIssueFineholderDetails', values.PlaceOfIssueFineholderDetails === 'Australia' ? 'StateOfIssueFineholderDetails' : []],
    driverLicenceYourDetailsIndividual: ['DRIVER_LICENCE', 'PlaceOfIssueYourDetailsIndividual', values.PlaceOfIssueYourDetailsIndividual === 'Australia' ? 'StateOfIssueYourDetailsIndividual' : []]
  };
  const {
    postalAddressFineholderDetails,
    residentialAddressFineholderDetails,
    postalAddressYourDetailsIndividual,
    residentialAddressYourDetailsIndividual,
    postalAddressYourDetailsThirdParty,
    postalAddressYourDetailsCompany,
    streetAddressYourDetailsCompany,
    contactNumberFineholderDetails,
    contactNumberYourDetailsIndividual,
    contactNumberYourDetailsThirdParty,
    contactNumberYourDetailsCompany,
    driverLicenceFineHolderDetails,
    driverLicenceYourDetailsIndividual
  } = reviewKeys;
  const reviewValidationKeys = {
    page0: [],
    page1: ['OBLIGATION_NUMBER'],
    page2: [
      values.OffenceDateRequired ? 'OFFENCE_DATE' : '',
      values.HearingDateRequired ? 'HEARING_DATE' : '',
      values.LicenceRequired ? 'DRIVER_LICENCE' : '',
      values.RegistrationRequired ? 'VEHICLE_REGISTRATION' : '',
      values.DOBRequired ? 'DOB' : '',
    ],
    page3: [
      values.isInternalReviewStage && values.isDebtorTypeIndividual && values.isNominatable ? 'WasSomeoneElseDrivingAtTimeOfOffence' : '',
      values.isInternalReviewStage && values.isDebtorTypeIndividual && values.Status === 'PenaltyReminder' ? 'ApplyingForPenaltyReminder' : '',
      values.isEnforcementReviewStage ? 'HaveYouSubmittedEnforcementReviewBefore' : '',
    ],
    page4: [
      'SaveYesNo',
      'SaveOptions',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'email' || values.SaveOptions === 'both') ? 'saveEmail' : '',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'mobile' || values.SaveOptions === 'both') ? 'saveMobile' : '',
    ],
    page5: [
      'isThePersonNamed',
      values.isThePersonNamed === 'false' ? 'isThirdPartyAuthorised' : [],
    ],
    page6: ['selectTheOption'],
    page7: ['selectTheSpecialOption'],
    page8: [
      'WhyYourFineShouldBeReviewed',
      'HasStatementAndEvidenceSupportingDocs',
      (values.isEnforcementReviewStage && (values.selectTheOption?.includes('SelectedGroundInfo1') || values.selectTheOption?.includes('SelectedGroundInfo4'))) ? 'IsMakingTimeRequest' : [],
      values.IsMakingTimeRequest === 'true' ? 'TimeExtension' : [],
      values.HasStatementAndEvidenceSupportingDocs === 'true' ? 'StatementAndEvidenceFileSectionError' : [],
      values.HasStatementAndEvidenceSupportingDocs === 'true' ? 'StatementAndEvidenceDescription' : [],
    ],
    page9: [
      'GivenNamesFineholderDetails',
      'FamilyNameFineholderDetails',
      'DOBFineholderDetails',
      ...(!values.YesNoDriverLicenceFineholderDetails ? driverLicenceFineHolderDetails : []),
      ...postalAddressFineholderDetails,
      'DifferentToPostalFineholderDetails',
      ...(values.DifferentToPostalFineholderDetails === 'true' ? residentialAddressFineholderDetails : []),
      ...contactNumberFineholderDetails,
      !values.YesNoEmailFineholderDetails ? 'EmailFineholderDetails' : [],
    ],
    page10: [
      ...(values.isDebtorTypeIndividual && !values.isThirdPartyAuthorised) ? [
        'GivenNamesYourDetailsIndividual',
        'FamilyNameYourDetailsIndividual',
        'DOBYourDetailsIndividual',
        ...(!values.YesNoDriverLicenceYourDetailsIndividual ? driverLicenceYourDetailsIndividual : []),
        ...postalAddressYourDetailsIndividual,
        'DifferentToPostalYourDetailsIndividual',
        ...(values.DifferentToPostalYourDetailsIndividual === 'true' ? residentialAddressYourDetailsIndividual : []),
        ...contactNumberYourDetailsIndividual,
        !values.YesNoEmailYourDetailsIndividual ? 'EmailYourDetailsIndividual' : [],
        (!values.YesNoEmailYourDetailsIndividual && values.selectTheOption?.includes('SelectedGroundInfo4')) ? 'ReceiveApplicationViaEmailYourDetailsIndividual' : [],
        (!values.YesNoEmailYourDetailsIndividual && values.isEnforcementReviewStage) ? 'ReceiveCorrespondenceViaEmailYourDetailsIndividual' : [],
      ] : [],
      ...values.isThirdPartyAuthorised ? [
        'GivenNamesYourDetailsThirdParty',
        'FamilyNameYourDetailsThirdParty',
        'RelationshipWithNamedPersonYourDetailsThirdParty',
        'OrganisationNameYourDetailsThirdParty',
        ...postalAddressYourDetailsThirdParty,
        ...contactNumberYourDetailsThirdParty,
        !values.YesNoEmailYourDetailsThirdParty ? 'EmailYourDetailsThirdParty' : [],
        (!values.YesNoEmailYourDetailsThirdParty && values.selectTheOption?.includes('SelectedGroundInfo4')) ? 'ReceiveApplicationViaEmailYourDetailsThirdParty' : [],
        (!values.YesNoEmailYourDetailsThirdParty && values.isEnforcementReviewStage) ? 'CorrespondenceRecipientYourDetailsThirdParty' : [],
      ] : [],
      ...(values.isDebtorTypeCompany && !values.isThirdPartyAuthorised) ? [
        'GivenNamesYourDetailsCompany',
        'FamilyNameYourDetailsCompany',
        'PositionInCompanyYourDetailsCompany',
        'CompanyNameYourDetailsCompany',
        'AbnAcnTypeYourDetailsCompany',
        values.AbnAcnTypeYourDetailsCompany === 'ABN' ? 'ABNYourDetailsCompany' : [],
        values.AbnAcnTypeYourDetailsCompany === 'ACN' ? 'ACNYourDetailsCompany' : [],
        ...postalAddressYourDetailsCompany,
        'DifferentToPostalYourDetailsCompany',
        ...(values.DifferentToPostalYourDetailsCompany === 'true' ? streetAddressYourDetailsCompany : []),
        ...contactNumberYourDetailsCompany,
        !values.YesNoEmailYourDetailsCompany ? 'EmailYourDetailsCompany' : [],
      ] : [],
    ],
    page11: [],
    page12: [
      'areThereAnyAdditionalFines',
      values.areThereAnyAdditionalFines === 'listFinesManually' && values.SelectedObligationsStep12.length === 0 ? 'obligationNumberToIncludeStep12' : []
    ],
    page13: [],
    page14: ['ReviewConsentToDeclaration'],
    page15: [],
  };
  /* Services - Review Keys --end */

  /* Services - Nomination Keys -- start */
  const nominationKeys = {
    personContactNumberSomeoneElse: ['IndividualContactNumberSomeoneElse', 'IndividualContactNumberSomeoneElse.ContactNumber'],
    companyContactNumberSomeoneElse: ['OrganisationContactNumberSomeoneElse', 'OrganisationContactNumberSomeoneElse.ContactNumber'],
    companyContactNumberYourDetails: ['OrganisationContactNumberYourDetailsCompany', 'OrganisationContactNumberYourDetailsCompany.ContactNumber'],
    individualContactNumberYourDetails: ['IndividualContactNumberYourDetails', 'IndividualContactNumberYourDetails.ContactNumber'],
    companyStreetAddressSomeoneElse: [
      'CompanyStreetAddressSomeoneElse',
      'CompanyStreetAddressSomeoneElse.LineOne',
      'CompanyStreetAddressSomeoneElse.LineTwo',
      'CompanyStreetAddressSomeoneElse.Suburb',
      'CompanyStreetAddressSomeoneElse.State',
      'CompanyStreetAddressSomeoneElse.Postcode',
      'CompanyStreetAddressSomeoneElse.Country',
    ],
    residentialAddressSomeoneElse: [
      'ResidentialAddressSomeoneElse',
      'ResidentialAddressSomeoneElse.LineOne',
      'ResidentialAddressSomeoneElse.LineTwo',
      'ResidentialAddressSomeoneElse.Suburb',
      'ResidentialAddressSomeoneElse.State',
      'ResidentialAddressSomeoneElse.Postcode',
      'ResidentialAddressSomeoneElse.Country',
    ],
    residentialAddressSoldDisposed: [
      'ResidentialAddressSoldDisposed',
      'ResidentialAddressSoldDisposed.LineOne',
      'ResidentialAddressSoldDisposed.LineTwo',
      'ResidentialAddressSoldDisposed.Suburb',
      'ResidentialAddressSoldDisposed.State',
      'ResidentialAddressSoldDisposed.Postcode',
      'ResidentialAddressSoldDisposed.Country',
    ],
    companyStreetAddressSoldDisposed: [
      'CompanyStreetAddressSoldDisposed',
      'CompanyStreetAddressSoldDisposed.LineOne',
      'CompanyStreetAddressSoldDisposed.LineTwo',
      'CompanyStreetAddressSoldDisposed.Suburb',
      'CompanyStreetAddressSoldDisposed.State',
      'CompanyStreetAddressSoldDisposed.Postcode',
      'CompanyStreetAddressSoldDisposed.Country',
    ],
    nominationCompanyStreetAddressYourDetails: [
      'CompanyStreetAddressYourDetails',
      'CompanyStreetAddressYourDetails.LineOne',
      'CompanyStreetAddressYourDetails.LineTwo',
      'CompanyStreetAddressYourDetails.Suburb',
      'CompanyStreetAddressYourDetails.State',
      'CompanyStreetAddressYourDetails.Postcode',
      'CompanyStreetAddressYourDetails.Country',
    ],
    nominationCompanyPostalAddressYourDetails: [
      'CompanyPostalAddressYourDetails',
      'CompanyPostalAddressYourDetails.LineOne',
      'CompanyPostalAddressYourDetails.LineTwo',
      'CompanyPostalAddressYourDetails.Suburb',
      'CompanyPostalAddressYourDetails.State',
      'CompanyPostalAddressYourDetails.Postcode',
      'CompanyPostalAddressYourDetails.Country',
    ],
    nominationIndividualPostalAddressYourDetails: [
      'IndividualPostalAddressYourDetails',
      'IndividualPostalAddressYourDetails.LineOne',
      'IndividualPostalAddressYourDetails.LineTwo',
      'IndividualPostalAddressYourDetails.Suburb',
      'IndividualPostalAddressYourDetails.State',
      'IndividualPostalAddressYourDetails.Postcode',
      'IndividualPostalAddressYourDetails.Country',
    ],
    nominationIndividualResidentialAddressYourDetails: [
      'ResidentialAddressYourDetails',
      'ResidentialAddressYourDetails.LineOne',
      'ResidentialAddressYourDetails.LineTwo',
      'ResidentialAddressYourDetails.Suburb',
      'ResidentialAddressYourDetails.State',
      'ResidentialAddressYourDetails.Postcode',
      'ResidentialAddressYourDetails.Country',
    ],
   driveLicenseStateSomeoneElse: ['DriverLicenseSomeoneElse', 'StatecountryOfIssueSomeoneElse', values.StatecountryOfIssueSomeoneElse === 'Australia' ? 'LicenceStateSomeoneElse' : []],
   driveLicenseStateSoldDisposed: ['DriverLicenseSoldDisposed', 'StatecountryOfIssueSoldDisposed', values.StatecountryOfIssueSoldDisposed === 'Australia' ? 'LicenceStateSoldDisposed' : []],
   personContactNumberSoldDisposed: ['IndividualContactNumberSoldDisposed', 'IndividualContactNumberSoldDisposed.ContactNumber'],
   companyContactNumberSoldDisposed: ['OrganisationContactNumberSoldDisposed', 'OrganisationContactNumberSoldDisposed.ContactNumber'],
   driveLicenseStateYourDetails: ['DRIVER_LICENCE', 'StatecountryOfIssueYourDetails', values.StatecountryOfIssueYourDetails === 'Australia' ? 'LicenceStateYourDetails' : []],
  };
  const { personContactNumberSomeoneElse,
    companyContactNumberSomeoneElse,
    companyStreetAddressSomeoneElse,
    residentialAddressSomeoneElse,
    driveLicenseStateSomeoneElse,
    residentialAddressSoldDisposed,
    companyStreetAddressSoldDisposed,
    nominationCompanyStreetAddressYourDetails,
    nominationCompanyPostalAddressYourDetails,
    driveLicenseStateSoldDisposed,
    personContactNumberSoldDisposed,
    companyContactNumberSoldDisposed,
    companyContactNumberYourDetails,
    driveLicenseStateYourDetails,
    nominationIndividualPostalAddressYourDetails,
    nominationIndividualResidentialAddressYourDetails,
    individualContactNumberYourDetails,
  } = nominationKeys;
  const nominationValidationKeys = {
    page0: [],
    page1: ['OBLIGATION_NUMBER'],
    page2: [
      values.OffenceDateRequired ? 'OFFENCE_DATE' : '',
      values.HearingDateRequired ? 'HEARING_DATE' : '',
      values.LicenceRequired ? 'DRIVER_LICENCE' : '',
      values.RegistrationRequired ? 'VEHICLE_REGISTRATION' : '',
      values.DOBRequired ? 'DOB' : '',
    ],
    page3: [
      'SaveYesNo',
      'SaveOptions',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'email' || values.SaveOptions === 'both') ? 'saveEmail' : '',
      values.SaveYesNo === 'true' && (values.SaveOptions === 'mobile' || values.SaveOptions === 'both') ? 'saveMobile' : '',
    ],
    page4: ['isThePersonNamed'],
    page5: ['selectTheOption'],
    page6: [
      'WhoAreYouNominating',
      ...(values.WhoAreYouNominating === 'Person' ? ['GivenNamesSomeoneElse', 'FamilyNameSomeoneElse', 'TaxDriverAccNumber', ...residentialAddressSomeoneElse] : []),
      ...(values.WhoAreYouNominating === 'Person' && !values.NoDriverLicenseSomeoneElse ? driveLicenseStateSomeoneElse : []),
      values.WhoAreYouNominating === 'Person' && !values.DOBYesNoSomeoneElse ? 'DOBSomeoneElse' : [],
      ...(values.WhoAreYouNominating === 'Person' && !values.NoContactNumberSomeoneElse ? personContactNumberSomeoneElse : []),
      values.WhoAreYouNominating === 'Person' && !values.NoEmailSomeoneElse ? 'EmailSomeoneElse' : [],
      ...(values.WhoAreYouNominating === 'Company' ? ['CompanyNameSomeoneElse', 'AbnacnTypeSomeoneElse', ...companyStreetAddressSomeoneElse] : []),
      values.AbnacnTypeSomeoneElse === 'ABN' ? 'AbnNoSomeoneElse' : [],
      values.AbnacnTypeSomeoneElse === 'ACN' ? 'AcnNoSomeoneElse' : [],
      ...(values.WhoAreYouNominating === 'Company' && !values.NoOrgContactNumberSomeoneElse ? companyContactNumberSomeoneElse : []),
      values.WhoAreYouNominating === 'Company' && !values.CompanyEmailYesNoSomeOneElse ? 'CompanyEmailSomeOneElse' : [],
    ],
    page7: [
      'TransferedVicRoads',
      'DateSellOrDispose',
      'EvidenceSoldOrDisposeNameField',
      'WhoAreYouNominatingSoldDispose',
      ...(values.WhoAreYouNominatingSoldDispose === 'Person' ? ['GivenNamesSoldDisposed', 'FamilyNameSoldDisposed', ...residentialAddressSoldDisposed] : []),
      ...(values.WhoAreYouNominatingSoldDispose === 'Person' && !values.NoDriverLicenseSoldDisposed ? driveLicenseStateSoldDisposed : []),
      values.WhoAreYouNominatingSoldDispose === 'Person' && !values.DOBYesNoSoldDisposed ? 'DOBSoldDisposed' : [],
      ...(values.WhoAreYouNominatingSoldDispose === 'Person' && !values.NoContactNumberSoldDisposed ? personContactNumberSoldDisposed : []),
      values.WhoAreYouNominatingSoldDispose === 'Person' && !values.NoEmailSoldDisposed ? 'EmailSoldDisposed' : [],
      ...(values.WhoAreYouNominatingSoldDispose === 'Company' ? ['CompanyNameSoldDisposed', 'AbnacnTypeSoldDisposed', ...companyStreetAddressSoldDisposed] : []),
      values.WhoAreYouNominatingSoldDispose === 'Company' && values.AbnacnTypeSoldDisposed === 'ABN' ? 'AbnNoSoldDisposed' : [],
      values.WhoAreYouNominatingSoldDispose === 'Company' && values.AbnacnTypeSoldDisposed === 'ACN' ? 'AcnNoSoldDisposed' : [],
      ...(values.WhoAreYouNominatingSoldDispose === 'Company' && !values.NoOrgContactNumberSoldDisposed ? companyContactNumberSoldDisposed : []),
      values.WhoAreYouNominatingSoldDispose === 'Company' && !values.CompanyEmailYesNoSoldDisposed ? 'CompanyEmailSoldDisposed' : [],
    ],
    page8: [
      'VictoriaPoliceReferenceNumber',
      'VehicleOrIdentificationStolenOrFalseFileSectionError'
    ],
    page9: [
      'IncorrectNominationExplanation',
      'RejectionSupportingDocsFileSectionError'
    ],
    page10: [
      'UnableToIdentifyExplanation',
      'UnableToIdentifyFileSectionError'
    ],
    page11: [...(!values.isDebtorTypeIndividual ?
      ['GivenNamesYourDetailsCompany',
      'FamilyNameYourDetailsCompany',
      'PositionInCompanyYourDetailsCompany',
      ...companyContactNumberYourDetails,
      ...(values.CompanyEmailYesNoYourDetails === '' ? ['CompanyEmailYourDetails'] : []),
      'CompanyNameYourDetailsCompany',
      'AbnacnTypeYourDetails',
      values.AbnacnTypeYourDetails === 'ABN' ? 'AbnNoYourDetails' : [],
      values.AbnacnTypeYourDetails === 'ACN' ? 'AcnNoYourDetails' : [],
      ...nominationCompanyStreetAddressYourDetails,
      'DifferentToStreetAddressYourDetails',
      ...(values.DifferentToStreetAddressYourDetails === 'true' ? nominationCompanyPostalAddressYourDetails : []),
      ] : [
        'GivenNamesYourDetails',
        'FamilyNameYourDetails',
        'DOBYourDetails',
        ...(!values.NoDriverLicenseYourDetails ? driveLicenseStateYourDetails : []),
        ...(nominationIndividualPostalAddressYourDetails),
        'DifferentToPostalYourDetails',
        ...(values.DifferentToPostalYourDetails === 'true' ? nominationIndividualResidentialAddressYourDetails : []),
        ...(individualContactNumberYourDetails),
        !values.NoEmailYourDetails ? 'EmailYourDetails' : [],
      ]),
    ],
    page12: [],
    page13: ['nominationConsentToDeclaration'],
    page14: [],
  };
  // Return validation keys based on the form template
  switch (template) {
    case THIRDPARTY:
      return thirdPartyValidationKeys;

    case COURT:
      return courtValidationKeys;

    case EXTENSION:
      return extensionValidationKeys;

    case FAMILYVIOLENCESCHEME:
      return fvsValidationKeys;

    case INFRINGEMENTEXTENSION:
      return infringementExtensionValidationKeys;

    case NOMINATION:
      return nominationValidationKeys;

    case INSTALMENT:
      return instalmentValidationKeys;

    case REVIEW:
      return reviewValidationKeys;

    default:
      return [];
  }
};

export default keys;
